export default  {
    tipoPessoa: {
        FISICA: 1,
        JURIDICA: 2,
    }
}


// WEBPACK FOOTER //
// ./src/helpers/tipo-pessoa-enum.js